import { ElementDimensions } from '@hooks/useElementDimensions';

const SCROLLWIDTH_THRESHOLD = 100;

export const getTotalPages = (dimensions: ElementDimensions | null): number => {
  // Not measured yet — treat as a single page until dimensions are known.
  if (!dimensions) {
    return 1;
  }

  const { scrollWidth, clientWidth } = dimensions;

  if (scrollWidth === 0) {
    return 0;
  }

  const isValidContainer =
    scrollWidth > SCROLLWIDTH_THRESHOLD && clientWidth > SCROLLWIDTH_THRESHOLD;

  if (!isValidContainer) {
    return 1;
  }

  return Math.ceil((scrollWidth - SCROLLWIDTH_THRESHOLD) / clientWidth);
};
